var map = {
	"./KeyboardIcons/backspace.svg": 2742,
	"./KeyboardIcons/close.svg": 1691,
	"./KeyboardIcons/eng_close.svg": 6002,
	"./KeyboardIcons/eng_go_back.svg": 4510,
	"./KeyboardIcons/go_back.svg": 1507,
	"./KeyboardIcons/lang_switch.svg": 2848,
	"./KeyboardIcons/shift.svg": 2563,
	"./KeyboardIcons/space.svg": 4213,
	"./Payment/card-in.svg": 2856,
	"./Payment/card-on.svg": 4578,
	"./barcode_reader.svg": 6869,
	"./dry cleaning.svg": 8143,
	"./ironing and package.svg": 268,
	"./ironing.svg": 4419,
	"./laundry ironing package.svg": 8672,
	"./laundry ironing.svg": 1648,
	"./laundry.svg": 8046,
	"./locker_orange.svg": 9716,
	"./trash.svg": 8339,
	"./wardrobe.svg": 787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;